<template>
  <b-card>
    <data-table
      :fields="fields"
      :items="courses"
      :loading="loading"
      @onRowClicked="
        $router.push({ name: 'show-course', params: { id: $event.id } })
      "
    >
      <template #id="{ data }">
        {{ data.item.id }}
      </template>

      <template #name="{ data }">{{ data.item.name }}</template>
      <template #available_at="{ data }">
        <b-badge variant="light-primary">
          {{ calcDate(data.item.available_at) || "-" }}
        </b-badge></template
      >
      <template #duration="{ data }">
        <b-badge variant="light-secondary">
          {{ data.item.duration }}
        </b-badge>
      </template>
      <template #final_amount="{ data }">{{ finalAmount(data.item) }}</template>
      <template #session_count="{ data }">{{
        data.item.session_count || "-"
      }}</template>
      <template #has_penalty="{ data }">{{
        data.item.has_penalty ? "دارد" : "ندارد"
      }}</template>
      <template #status="{ data }">
        <b-badge :variant="data.item.active ? 'light-success' : 'light-danger'"
          >{{ data.item.active ? "فعال" : "غیر فعال" }}
        </b-badge>
      </template>
      <template #actions="{ data }">
        <b-button
          size="sm"
          variant="flat-primary"
          :to="{
            name: 'show-course',
            params: { id: data.item.id },
          }"
        >
          <feather-icon icon="EyeIcon" />
          <span class="ml-50">مشاهده</span>
        </b-button>
      </template>
    </data-table>
    <div
      class="w-100 d-flex flex-wrap align-items-center justify-content-center"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        size="md"
        class="my-2 d-flex justify-content-center"
      ></b-pagination>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BCard,
  BPagination,
  BLink,
  BDropdownItem,
  BDropdown,
  BFormCheckbox,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import qs from "qs";

export default {
  components: {
    DataTable,
    BButton,
    BModal,
    VBModal,
    BCard,
    BBadge,
    BPagination,
    BLink,
    BDropdownItem,
    BDropdown,
    BFormCheckbox,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      courses: [],
      loading: false,
      currentPage: 1,
      pagination: {},
      visible: false,
      fields: [
        { key: "id", label: "شناسه" },
        { key: "name", label: "نام" },
        { key: "available_at", label: "زمان دسترسی" },
        { key: "has_penalty", label: "جریمه فعال" },
        { key: "duration", label: "طول دوره (روز)" },
        { key: "final_amount", label: "قیمت دوره (تومان)" },
        { key: "session_count", label: "تعداد درس" },
        { key: "status", label: "وضعیت" },
        { key: "actions", label: "" },
      ],
    };
  },
  // props: {
  //   courses: {
  //     type: Array,
  //     default: () => [],
  //   },
  // },
  watch: {
    $route: {
      handler(val) {
        this.getCourses();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: this.$route.params.id ? "user-courses" : "profile-courses",
          query: {
            page: val,
          },
        });
      }
    },
  },

  methods: {
    finalAmount(item) {
      let finalAmount = 0;
      if (item.percentage) {
        finalAmount =
          Number(item.amount) -
          (Number(item.amount) * Number(item.rebate)) / 100;
      } else {
        finalAmount = Number(item.amount) - Number(item.rebate);
      }

      return finalAmount > 0
        ? this.decodePersianName(String(parseInt(finalAmount)))
        : "0";
    },

    async getCourses() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        if (this.$route.params.id) {
          params.filters = {
            user_id: this.$route.params.id,
          };
        }

        const { data } = await this.$http.get(`/panel/courses`, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.courses = data.data.courses;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
